import React from "react";

// A heading that ends with the coral brand dot.
export function Dot() {
  return <span className="dot">.</span>;
}

// Phone frame with light and dark screenshots that follow the theme.
export function Phone({ shot, alt, className = "" }) {
  return (
    <div className={`phone ${className}`}>
      <div className="screen">
        <img className="light-only" src={`/img/light-${shot}.webp`} alt={alt} width="540" height="1169" loading={className.includes("front") ? "eager" : "lazy"} />
        <img className="dark-only" src={`/img/dark-${shot}.webp`} alt={alt} width="540" height="1169" loading="lazy" />
      </div>
    </div>
  );
}

// Page header: small keyword line inside the H1, then the headline.
export function PageHead({ kicker, title, lede, children }) {
  return (
    <section className="page-head">
      <div className="wrap">
        <h1>
          <span className="label h1-kicker">{kicker}</span>
          {title}
          <Dot />
        </h1>
        {lede && <p className="lede">{lede}</p>}
        {children}
      </div>
    </section>
  );
}
